module.exports = __webpack_public_path__ + "static/media/texture (19).6d0c605c.jpg";